// Форматирование дат
export const formatDisplayDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

export const formatDateForInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return 'Не указано';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  } catch {
    return dateString;
  }
};

// Дата и подписка
export const getDaysBetween = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffTime = Math.abs(endDate - startDate);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const calculatePrice = (days) => {
  const monthlyPrice = 55;
  const dailyPrice = monthlyPrice / 30;
  return Math.round(dailyPrice * days * 100) / 100;
};

export const getPlanName = (duration) => {
  switch (duration) {
    case '1': return 'Premium Monthly';
    case '3': return 'Premium Quarterly';
    case '6': return 'Premium Yearly';
    default: return 'Premium Monthly';
  }
};

export const getPlanId = (duration) => {
  switch (duration) {
    case '1': return 'premium_monthly';
    case '3': return 'premium_quarterly';
    case '6': return 'premium_yearly';
    default: return 'premium_monthly';
  }
};

export const getPlanPrice = (duration) => {
  switch (duration) {
    case '1': return 55;
    case '3': return 148;
    case '6': return 247;
    default: return 55;
  }
};

export const getPremiumRemaining = (expiresAt) => {
  if (!expiresAt) return '';
  
  const now = new Date();
  const expiry = new Date(expiresAt);
  const diffTime = expiry - now;
  
  if (diffTime <= 0) return 'Истек';
  
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return `${diffDays} дн.`;
};

// Иконки и текст
export const getActivationTypeIcon = (type) => {
  const icons = {
    'auto': 'Zap',
    'manual': 'Bot'
  };
  return icons[type] || null;
};

export const getActivationTypeText = (type) => {
  switch (type) {
    case 'auto': return 'Авто';
    case 'manual': return 'Ручная';
    default: return '—';
  }
};